import { render, staticRenderFns } from "./registeredByMainDealer.vue?vue&type=template&id=dab03a3e"
import script from "./registeredByMainDealer.vue?vue&type=script&lang=js"
export * from "./registeredByMainDealer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports